import { render, staticRenderFns } from "./school5.vue?vue&type=template&id=c5e36a42&scoped=true&"
import script from "./school5.vue?vue&type=script&lang=js&"
export * from "./school5.vue?vue&type=script&lang=js&"
import style0 from "./school5.vue?vue&type=style&index=0&id=c5e36a42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e36a42",
  null
  
)

export default component.exports